// extracted by mini-css-extract-plugin
export var content = "_pw-1";
export var divider = "_pw-0";